module.exports = __webpack_public_path__ + "img/forgot_password.ae19f933.svg";